import * as Yup from 'yup';

export const interestRateCalculatorValidation = Yup.object().shape({
    amountFinanced: Yup.number().required('Amount is required').nullable(),
    term: Yup.number().required('Term is required').nullable(),
    paymentAmount: Yup.number().required('Payment is required').nullable(),
});

export const amortizationDetailerValidation = Yup.object().shape({
    amortFinanced: Yup.number().required('Amount is required').nullable(),
    amortTerm: Yup.number().required('Term is required').nullable(),
    amortApr: Yup.number().required('Apr is required').nullable(),
});